import $ from 'jquery';

import createProductRail from 'chairisher/view/helper/rail';
import FolderMenuView from 'chairisher/view/folder/menu';
import ModalViewHelper from 'chairisher/view/helper/modal';
import ToggleView from 'chairisher/view/toggle';
import Scroller from 'chairisher/component/scroller';
import SearchController from 'chairisher/controller/search';
import UriUtils from 'chairisher/util/uri';

import { trackCollectionScreenView } from 'chairisher/analytics/search';
import { getCollectionId, getFolderDeactivateUrl, isFolder } from 'chairisher/context/collection';
import { getRecentlyViewedUrl } from 'chairisher/context/product';
import { setNewWindowTitleOnLinks, setAriaLabelForVagueLinks } from 'chairisher/util/accessibility';
import {
    CollectionPosition,
    ProductRailType,
    logAmplitudeEvent,
    logAmplitudeLinkClickEvent,
} from 'chairisher/util/analytics';

/**
 * Controller that binds actions for query and curated collection pages
 */
class CollectionController extends SearchController {
    constructor() {
        super();
        this.merchTool = null;
    }

    /** @inheritDoc * */
    bindPageActions() {
        super.bindPageActions();

        // add recently viewed rail
        const rvProductsIdSelector = '#js-recently-viewed';
        createProductRail({
            $containerEl: $(rvProductsIdSelector),
            $el: $(`${rvProductsIdSelector}-scrollable-grid`),
            analyticsTrackingType: ProductRailType.RECENTLY_VIEWED,
            listSelector: rvProductsIdSelector,
            railUrl: getRecentlyViewedUrl(),
        });

        const $moreContent = $('#js-conclusion-more').collapse({
            toggle: false,
        });

        const $expandArticle = $('#js-conclusion-expand');
        $expandArticle.on('click', (e) => {
            e.preventDefault();
            $(e.currentTarget).remove();
            $moreContent.collapse('show');
        });

        if (window.chairisher.context.urlHash === '#article') {
            $expandArticle.trigger('click');
        }

        const collectionConclusionSelector = '.js-collection-conclusion';
        setNewWindowTitleOnLinks(collectionConclusionSelector);
        setAriaLabelForVagueLinks(collectionConclusionSelector);

        this.toggleRelatedCollections();

        $('.js-related-collection-tiles').on('click', '.js-tile-link', (e) => {
            const $link = $(e.currentTarget);

            logAmplitudeLinkClickEvent(
                $link.find('.js-tile-title').text().trim(),
                $link.attr('href'),
                CollectionPosition.VISUAL_NAV,
            );
        });

        $('.js-simple-query a').on('click', (e) => {
            const $link = $(e.currentTarget);
            logAmplitudeLinkClickEvent($link.text().trim(), $link.attr('href'), CollectionPosition.SIMPLE_QUERY_SEARCH);
        });

        if (isFolder()) {
            FolderMenuView.create({
                $deactivateTriggerEl: $('.js-action-deactivate'),
                $menuEl: $('.js-folder-menu'),
                $menuTriggerEls: $('.js-folder-edit-trigger, .js-folder-edit-close-trigger'),
                collectionId: getCollectionId(),
                deactivateUrl: getFolderDeactivateUrl(),
            });
        }

        // bind the edit mode toggle
        const editModeToggle = new ToggleView({ toggleSelector: '.js-toggle-edit-mode' });

        $('.js-toggle-edit-mode').on('click', (e) => {
            e.preventDefault();
            editModeToggle.toggle(true);
            window.location.href = editModeToggle.getEl().data('toggle-url');
        });

        const $extendedNav = $('.js-extended-nav');

        if ($extendedNav.length && !UriUtils.extractParamFromUri(document.location.search, 'sold')) {
            $extendedNav.on('click', '.js-view-all', (e) => {
                e.preventDefault();

                const $link = $(e.currentTarget);

                logAmplitudeLinkClickEvent(
                    $link.text().toLowerCase(),
                    $link.attr('href'),
                    CollectionPosition.EXTENDED_NAV_SUBCATEGORIES,
                );

                $('html, body').animate({
                    scrollTop: $('.js-collection-header').offset().top - $('#js-global-nav').outerHeight(),
                });
            });

            $extendedNav.on('click', '.js-tile-toggle', (e) => {
                e.preventDefault();
                $extendedNav.find('.js-tile-toggle').toggleClass('hidden');
                $extendedNav.find('.js-tile-list').addClass('tile-list-expanded');
                $extendedNav.find('.js-subcategory-tiles').addClass('tile-list-expanded');
                $extendedNav.find('.js-scroll-left').remove();
                $extendedNav.find('.js-scroll-right').remove();
            });

            $extendedNav.on('click', '.js-tile-link', ({ currentTarget }) => {
                const $link = $(currentTarget);

                logAmplitudeLinkClickEvent(
                    $link.text().toLowerCase(),
                    $link.attr('href'),
                    CollectionPosition.EXTENDED_NAV_SUBCATEGORIES,
                );
            });

            const $subcatagoryTileContainer = $('.js-subcategory-tiles');
            if ($subcatagoryTileContainer.length) {
                Scroller.create({
                    container: $subcatagoryTileContainer.get(0),
                    containerBody: $subcatagoryTileContainer.find('.js-tile-list').get(0),
                    children: $subcatagoryTileContainer.find('.js-tile-list').children().get(),
                });
            }

            if (UriUtils.extractParamFromUri(document.location.search, 'is_markdown') === '1') {
                window.setTimeout(() => {
                    $('html, body').animate({
                        scrollTop: $('.js-collection-header').offset().top - $('#js-global-nav').outerHeight(),
                    });
                }, 100);
            }
        }

        if (UriUtils.extractParamFromUri(document.location.search, 'trade-signup-success')) {
            ModalViewHelper.renderModalFromTemplate('#js-known-trade-signup-success-modal');
            logAmplitudeEvent('known trade signup - success');
        }
    }

    /** @inheritDoc * */
    bindScreenAnalytics() {
        trackCollectionScreenView();
    }

    /** @inheritDoc * */
    submit(shouldResize, shouldPersist, shouldBindScreenAnalytics) {
        this.toggleRelatedCollections();
        super.submit(shouldResize, shouldPersist, shouldBindScreenAnalytics).done(() => {
            this.toggleRelatedCollections();
        });
    }

    /**
     * Toggle the visibility of the related collections nav depending on whether or not facets are selected
     */
    toggleRelatedCollections() {
        const $relatedTiles = $('.js-related-collection-tiles');
        const $collectionHeader = $('.js-collection-header');
        const hasSelections = this.searchView.hasSelections();
        if ($relatedTiles.find('.js-tile').length) {
            $relatedTiles.toggleClass('hidden', hasSelections);
            $collectionHeader.toggleClass('collection-header-with-tiles', !hasSelections);
        }
    }
}

export default CollectionController;
